import { useTranslation } from 'react-i18next'
import { Bell } from 'lucide-react'
import clsx from 'clsx'

interface Props {
  checkOutAt: string | null | undefined
  /** Omit when the caller only owns attendance data; preview API resolves lesson availability. */
  completedLessonCount?: number
  onClick: () => void
  compact?: boolean
}

/**
 * 성장 알림 버튼 — 순수 표시용(데이터 패칭 없음).
 * 활성화 조건만 로컬에서 판단하고, 다이얼로그 열기는 부모의 onClick 에 위임한다.
 * - 하원(checkOutAt) 전: 비활성 + "수업 종료 후 확인할 수 있습니다."
 * - 하원했지만 완료 레슨 없음: 비활성 + "완료된 레슨이 없습니다."
 * - 그 외: 활성 (사유 텍스트 없음)
 */
export function GrowthAlertButton({ checkOutAt, completedLessonCount, onClick, compact = false }: Props) {
  const { t } = useTranslation('coaching')

  const reasonKey = !checkOutAt
    ? 'growthAlert.unavailable.SESSION_NOT_ENDED'
    : completedLessonCount != null && completedLessonCount < 1
      ? 'growthAlert.unavailable.NO_COMPLETED_LESSON'
      : null
  const disabled = reasonKey !== null

  return (
    <div className={clsx('flex flex-col', compact ? 'gap-0.5' : 'gap-1')}>
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className={clsx(
          'inline-flex items-center justify-center gap-1.5 rounded-lg font-semibold transition-colors',
          compact ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-sm',
          disabled
            ? 'cursor-not-allowed bg-gray-100 text-gray-400'
            : 'bg-indigo-600 text-white hover:bg-indigo-700',
        )}
      >
        <Bell className={compact ? 'h-3.5 w-3.5' : 'h-4 w-4'} aria-hidden="true" />
        {t('growthAlert.button')}
      </button>
      {reasonKey !== null ? (
        <p className={clsx('text-gray-400', compact ? 'text-[11px]' : 'text-xs')}>{t(reasonKey)}</p>
      ) : null}
    </div>
  )
}
